/**
 * This function checks if the provided query object contains an 'landingPageCode' property.
 * If it does, it indicates that the page is a landing page.
 *
 * @param {EditModeQuery} query - The query object to check.
 * @returns {query is LandingPageQuery} True if the query is a landing page, false otherwise.
 */
export default function isLandingPageQuery(query) {
  return 'landingPageCode' in query;
}
